<template>
<div class="footer color-picker__wrapper" :style="{ backgroundColor: `#${bgColor}` }">
    <!-- <h1 class="user-speach">
      <v-flex class="space" />
      <div class="typing" color="primary">
                <span>{{ speak }}</span>
      </div>
    </h1> -->

    <div class="mic-animate" id="start-animate" v-bind:class="{ 'start-animate': micOn }" @click="startSpeaking()">
      <AnimationCogOrb ref="wake" src="@/assets/mic.svg" class="mic2" />
      
    </div>
    <GmailCompose :show-email="showEmail" v-if="showEmail"></GmailCompose>
    <v-overlay :value="overlay" opacity="0.98" z-index="9">
    <VoiceVisualizer :show-voice="showVoice" v-if="showVoice"></VoiceVisualizer>
    </v-overlay>   
    <Animation6 class="animation2" />
    <p class="copyright">COGNEETIV AI © 2024<v-spacer /></p>     
  </div>
</template>

<script>
import AnimationCogOrb from './AnimationCogOrb.vue';
import startAudio from '../assets/audio/Cogneetiv-Ping-AI-2.wav';
import startAudioVisual from '../assets/audio/CogDing.wav';
import startAudioDark from '../assets/audio/Dark.wav';
import startAudioLight from '../assets/audio/Light.wav';
import startAudioDimmer from '../assets/audio/Dimmer.wav';
// import startAudioLightTwo from '../assets/audio/Lighttwo.wav';
import startAudioChange from '../assets/audio/Change.wav';
import startAudioLightsOff from '../assets/audio/Lightsoff.wav';
import startAudioBrightOn from '../assets/audio/BrightOn.wav';
import startAudioBrightOff from '../assets/audio/BrightOff.wav';
import startAudio2 from '@/assets/audio/mapsearch.wav';
import Animation6 from '@/components/Animation6.vue';
// import { EventBus } from '../Event';

export default {
  name: 'Footer',
    props: {
    msg: String
  },
  components: {
    AnimationCogOrb,
    Animation6,
    GmailCompose: () => import('@/components/GmailCompose.vue'),
    VoiceVisualizer: () => import('@/components/VoiceVisualizer.vue'),
  },
  data: () => ({
    speak: '',
    overlay: false,
    micOn: false,
    playing: false,
    showEmail: false,
    dialog: false,
    showVoice: false,
    requestType: '',
    currentRoute: '',
    userInfo: {},
    mtype: null,
    media: null,
    isMobile: false,
    date: '',
    time: '',
    year: '',
    timestamp: '',
    fulldatetime: ''
  }),
  methods: {
    startSpeaking: function() {
      new Audio(startAudio).play();

      let instance = this;
      this.recognition.stop();
      this.recognition.start();
      this.Device = {
          isMobile: false,
          isChrome: true
      };
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        this.Device.isMobile = true;
      }
      if (navigator.userAgent.indexOf('Chrome') == -1) {
        this.Device.isChrome = true;
      }
      this.recognition.onstart = function() {
        instance.micOn = true;
      };
      this.recognition.onend = function() {
        instance.micOn = false;
      };
      this.recognition.onerror = function() {
        instance.micOn = false;
      };
      this.recognition.onresult = function(e) {
        let transcript = e.results[0][0].transcript.toLowerCase();
        this.speak = transcript;
        instance.alfred(transcript);
      };
    },
    readOutLoud: function(msg) {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Female';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      this.speak = msg;
      this.showVoice = true;
      let instance = this;

      speech.onend = function() {
        instance.startSpeaking();
        this.showVoice = false;
      };
    },
    wakeUp: function() {
    this.recognition.SpeechRecognition = function() {
        this.recognition.interimResults = true;
        this.recognition.lang = 'en-GB';
        this.recognition.start();
      };
    },
    getTime: function() {
      let date = new Date();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let strTime = hours + ':' + minutes + ' ' + ampm;
      this.dialog = true;
      return strTime;
    },

    checkForRoutes: function(msg) {
      //This function will check what is the route and based on route it will send message to that route
      if (msg.indexOf('search') != -1) {
        msg = msg.replace('search', '').trim();
        Event.$emit('searchFromRecord', { msg });
      } else if (msg.indexOf('edit') != -1) {
        Event.$emit('editFromRecord', { msg });
      }
    },
    alfred: async function(msg) {
      const command = 'dashboard'; // Replace with actual command recognition logic
Event.$emit('commandReceived', command);

      console.log(msg);
      if (this.requestType == 'search' && msg.indexOf('search') != -1) {
        this.checkForRoutes(msg); // We will use this method to do search all over the project
        return;
      }

      if (this.requestType == 'startForm') {
        //If user has started Form ---block
        if (msg === 'verified') {
          this.requestType = '';
        } else if (msg.indexOf('cancel form') != -1) {
          this.requestType = '';
        }
        Event.$emit('formDetails', { msg });
        return;
      }

      /* NAVIGATE COMMAND */
      if (msg.indexOf('navigate') != -1) {
        this.requestType = '';
        if (msg.indexOf('dashboard') != -1) {
          this.$router.push({ name: 'Dashboard' });
        } else if (msg.indexOf('in stock apple products') != -1) {
          this.$router.push({ name: 'AvailableApple' });
        } else if (msg.indexOf('in stock samsung products') != -1) {
          this.$router.push({ name: 'AvailableSamsung' });
        } else if (msg.indexOf('leads') != -1) {
          this.$router.push({ name: 'Leads' });
        } else if (msg.indexOf('leeds') != -1) {
          this.$router.push({ name: 'Leads' });
        } else if (msg.indexOf('inventory') != -1) {
          this.$router.push({ name: 'Inventory' });
        } else if (msg.indexOf('accounts') != -1) {
          this.$router.push({ name: 'Accounts' });
        } else if (msg.indexOf('buybacks') != -1) {
          this.$router.push({ name: 'BuybackOrders' });
        } else if (msg.indexOf('contacts') != -1) {
          this.$router.push({ name: 'Contacts' });
        } else if (msg.indexOf('vendors') != -1) {
          this.$router.push({ name: 'Vendors' });
        } else if (msg.indexOf('purchase orders') != -1) {
          this.$router.push({ name: 'PurchaseOrders' });
        } else if (msg.indexOf('product matrix') != -1) {
          this.$router.push({ name: 'ProductMatrix' });
        } else if (msg.indexOf('invoices') != -1) {
          this.$router.push({ name: 'Invoices' });
        } else if (msg.indexOf('sells') != -1) {
          this.$router.push({ name: 'Sales' });
        } else if (msg.indexOf('creator') != -1) {
          this.$router.push({ name: 'Creator' });
        } else if (msg.indexOf('intel') != -1) {
          this.$router.push({ name: 'Intel' });
        } else if (msg.indexOf('program') != -1) {
          this.$router.push({ name: 'Program' });
        } else if (msg.indexOf('designer') != -1) {
          this.$router.push({ name: 'Designer' });
        } else if (msg.indexOf('quotes') != -1) {
          this.$router.push({ name: 'Quotes' });
        } else if (msg.indexOf('tasks') != -1) {
          this.$router.push({ name: 'Tasks' });
        } else if (msg.indexOf('interface') != -1) {
          this.$router.push({ name: 'Interface' });
        } else if (msg.indexOf('mission control') != -1) {
          this.$router.push({ name: 'MissionControl' });
        } else if (msg.indexOf('daily briefing') != -1) {
          this.$router.push({ name: 'DailyBriefing' });
        } else if (msg.indexOf('proposals') != -1) {
          this.$router.push({ name: 'Proposals' });
        } else if (msg.indexOf('proposal') != -1) {
          this.$router.push({ name: 'Proposals' });
        }
      } else if (msg.indexOf('logout') != -1 || msg.indexOf('log out') != -1) {
        this.$router.push({ name: 'Login' });
        return;
      } else if (msg.indexOf('dark mode') != -1 || msg.indexOf('dark') != -1) {
        new Audio(startAudioDark).play();
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        return;
      } else if (msg.indexOf('undarken') != -1) {
        new Audio(startAudioLight).play();
        this.$vuetify.theme = !this.$vuetify.theme;
        return;
      } else if (msg.indexOf('next') != -1) {
        this.$refs.slick.next();
        return;
      } else if (msg.indexOf('previous') != -1) {
        this.$refs.slick.prev();
        return;
      } else if (msg.indexOf('google') !== -1) {
        //  Using "google"  word for searching content
        window.open('https://www.google.com/search?q=' + msg.replace('google', ''), '_blank');
      } else if (msg.indexOf('go to') !== -1) {
        window.open('https://www.' + msg.replace('go to', ''), '_blank');
      } else if (msg.indexOf('open offerup') !== -1) {
        window.open('https://' + msg.replace('open offerup', 'offerup.com/'), '_blank');
      } else if (msg.indexOf('open gmail') !== -1) {
        window.open('https://' + msg.replace('open gmail', 'mail.google.com/mail/u/0/#inbox'), '_blank','0','0', {toolbar:1, resizable:1, location:1, menubar:1, status:1} );
        // window.screen.moveTo(2500, 50);
        // window.open('http://www.google.com','google.com','0','0', {toolbar:1, resizable:1, location:2, menubar:1, status:1}); 
      } else if (msg.indexOf('open calendar') !== -1) {
        window.open('https://' + msg.replace('open calendar', 'calendar.google.com/calendar/'), '_blank');
      } else if (msg.indexOf('open google drive') !== -1) {
        window.open('https://' + msg.replace('open google drive', 'google.com/drive/'), '_blank');
      } else if (msg.indexOf('open trading') !== -1) {
        window.open('https://' + msg.replace('open trading', 'mintable.app/profile/my-wallet/'), '_blank');
      } else if (msg.indexOf('open photos') !== -1) {
        window.open('https://photos.google.com/?pli=1', '_blank');
      } else if (msg.indexOf('lights turned on') != -1 || msg.indexOf('turn lights on') != -1 || msg.indexOf('lights on') != -1 || msg.indexOf('turn on lights') != -1 || msg.indexOf('lights enabled') != -1 || msg.indexOf('activate lights') != -1) {
        new Audio(startAudioLight).play();
        this.readOutLoud('Lights on');
        window.fetch('https://maker.ifttt.com/trigger/on_lights/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights turned off') != -1 || msg.indexOf('turn lights off') != -1 || msg.indexOf('lights off') != -1 || msg.indexOf('turn off lights') != -1  || msg.indexOf('lights disabled') != -1 || msg.indexOf('deactivate lights') != -1) {
        new Audio(startAudioLightsOff).play();
        this.readOutLoud('Lights off');
        window.fetch('https://maker.ifttt.com/trigger/lights_off/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('glide on') !== -1) {
        new Audio(startAudioBrightOn).play();
        this.readOutLoud('Govee Lights on');
        window.fetch('https://maker.ifttt.com/trigger/govee_on/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('glide off') !== -1) {
        new Audio(startAudioBrightOff).play();
        this.readOutLoud('Govee Lights off');
        window.fetch('https://maker.ifttt.com/trigger/govee_off/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights white') !== -1) {
        new Audio(startAudioChange).play();
        this.readOutLoud('Light color changed to white');
        window.fetch('https://maker.ifttt.com/trigger/lights_color_white/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights blue') !== -1) {
        new Audio(startAudioChange).play();
        this.readOutLoud('Light color changed to blue');
        window.fetch('https://maker.ifttt.com/trigger/lights_color_blue/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights red') !== -1) {
        new Audio(startAudioChange).play();
        this.readOutLoud('Light color changed to red');
        window.fetch('https://maker.ifttt.com/trigger/lights_color_red/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights night mode') !== -1) {
        new Audio(startAudioChange).play();
        this.readOutLoud('Light color changed to night mode');
        window.fetch('https://maker.ifttt.com/trigger/lights_color_night/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 20') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to twenty percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_twenty/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 40') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to forty percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_forty/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 60') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to sixty percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_sixty/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 80') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to eighty percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_eighty/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('lights to 100') !== -1) {
        new Audio(startAudioDimmer).play();
        this.readOutLoud('Light to one hundred percent');
        window.fetch('https://maker.ifttt.com/trigger/lights_one_hundred/json/with/key/clnrzDZO-kPT8OgEwz_qpJ');
      } else if (msg.indexOf('open github') !== -1) {
        window.open('https://github.com/', '_blank');
      } else if (msg.indexOf('open stock tech') !== -1) {
        window.open('https://stocktech.ai/', '_blank');
      } else if (msg.indexOf('open erp') !== -1) {
        window.open('https://us.erp.gold/', '_blank');
      } else if (msg.indexOf('open zoho') !== -1) {
        window.open('https://zoho.com/', '_blank');
      } else if (msg.indexOf('open phone check') !== -1) {
        window.open('https:// cloudportal.phonecheck.com/cloud/Login', '_blank');
      } else if (msg.indexOf('open ebay') !== -1) {
        window.open('https://ebay.com/', '_blank');
      } else if (msg.indexOf('open gazelle') !== -1) {
        window.open('https://gazelle.com/', '_blank');
      } else if (msg.indexOf('open amazon') !== -1) {
        window.open('https://amazon.com/', '_blank');
      } else if (msg.indexOf('open my business') !== -1) {
        window.open('https://google.com/business/business-profile/', '_blank');
      } else if (msg.indexOf('open codex') !== -1) {
        window.open('https://beta.openai.com/codex-javascript-sandbox', '_blank');
      } else if (msg.indexOf('open time logix') !== -1) {
        window.open('https://time-logix.net', '_blank');
      } else if (msg.indexOf('open facebook') !== -1) {
        window.open('https://facebook.com/', '_blank');
      } else if (msg.indexOf('open instagram') !== -1) {
        window.open('https://instagram.com/', '_blank');
      } else if (msg.indexOf('open youtube') !== -1) {
        window.open('https://youtube.com/', '_blank');
      } else if (msg.indexOf('open netflix') !== -1) {
        window.open('https://netflix.com/', '_blank');
      } else if (msg.indexOf('open title') !== -1) {
        window.open('https://tidal.com/', '_blank');
      // } else if (msg.indexOf('open out look') !== -1) {
      //   window.open('C:/Program Files/Microsoft Office/root/Office16/OUTLOOK.exe');
      } else if (msg.indexOf('order food') !== -1) {
        window.open('https://food.google.com/', '_blank');
      } else if (msg.indexOf('open project') !== -1) {
        window.open('https://' + 'macheenist.atlassian.net/jira/software/projects/CF/boards/2', '_blank');
      } else if (msg.indexOf('initiate price research') !== -1) {
        window.open('https://buybackandrepair.com/', '_blank');
      } else if (msg.indexOf('initiate erp systems') !== -1) {
        window.open(
          'http://' + msg.replace('initiate erp systems', 'localhost:8080/#/leads'),
          '_blank',

          window.open('https://' + msg.replace('initiate erp systems', 'erp.gold/'), '_blank'),

          window.open('https://' + msg.replace('initiate erp systems', 'zoho.com/crm/?zmc=zoho-fa&ireft=ohome'), '_blank')
        );
      } else if (msg.indexOf('create') != -1) {
        this.requestType = 'startForm';

        if (msg.indexOf('lead') != -1) {
          if (this.$route.path !== '/leads') {
            this.$router.push({ name: 'Leads' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('purchase order') != -1 || msg.indexOf('purchaseorder') != -1) {
          if (this.$route.path !== '/purchaseorders') {
            this.$router.push({ name: 'PurchaseOrders' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('inventory') != -1) {
          if (this.$route.path !== '/inventory') {
            this.$router.push({ name: 'Inventory' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('repair') != -1) {
          if (this.$route.path !== '/repairs') {
            this.$router.push({ name: 'Repairs' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('fulfillment') != -1) {
          if (this.$route.path !== '/fulfillments') {
            this.$router.push({ name: 'Fulfillments' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('task') != -1) {
          if (this.$route.path !== '/tasks') {
            this.$router.push({ name: 'Tasks' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('productmatrix') != -1) {
          if (this.$route.path !== '/productmatrix') {
            this.$router.push({ name: 'ProductMatrix' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('contact') != -1) {
          if (this.$route.path !== '/contacts') {
            this.$router.push({ name: 'Contacts' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('account') != -1) {
          if (this.$route.path !== '/accounts') {
            this.$router.push({ name: 'Accounts' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('vendor') != -1) {
          if (this.$route.path !== '/vendors') {
            this.$router.push({ name: 'Vendors' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('buyback') != -1) {
          if (this.$route.path !== '/buybackorders') {
            this.$router.push({ name: 'BuybackOrders' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('quote') != -1) {
          if (this.$route.path !== '/quotes') {
            this.$router.push({ name: 'Quotes' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        } else if (msg.indexOf('invoice') != -1) {
          if (this.$route.path !== '/invoices') {
            this.$router.push({ name: 'Invoices' });
            setTimeout(() => {
              Event.$emit('openForm', { msg });
            }, 500);
          } else {
            Event.$emit('openForm', { msg });
          }
        }
      } else if (msg.indexOf('edit') != -1 || msg.indexOf('update') != -1) {
        this.requestType = 'editForm';
        Event.$emit('editFromRecord', { msg });
      } else if (msg.indexOf('computer') != -1) {
        let index = msg.indexOf('computer');
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);       
        
        msg = msg.slice(index + 9);
        if (msg == '') return;
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud(message);
        setTimeout(() => {
          this.overlay = false;
        }, 12000);

     } else if (msg.indexOf('research') != -1) {
        let index = msg.indexOf('research');
        this.showVoice = true;
        this.overlay = true;
        
        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);       
        
        if (this.$route.path !== '/googlevoicesearch') {
        this.$router.push({ name: 'GoogleVoiceSearch' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
         const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Commencing enhanced research for' + msg + '.......' + '' + message);
        setTimeout(() => {
        this.overlay = false;
          window.open('https://www.google.com/search?q=' + msg.replace('research', ''), '_blank');
        }, 15000);
      } else if (msg.indexOf('creative') != -1) {
        let index = msg.indexOf('creative');
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);
      
        if (this.$route.path !== '/creator') {
        this.$router.push({ name: 'Creator' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence2`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Creative: ' + message);
        setTimeout(() => {
          this.overlay = false;
        }, 8000);

        } else if (msg.indexOf('program') != -1) {
        let index = msg.indexOf('program');
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500); 

        if (this.$route.path !== '/program') {
        this.$router.push({ name: 'Program' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-codex`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Generated Program: ' + message);
        setTimeout(() => {
          this.overlay = false;
        }, 8000);
        } else if (msg.indexOf('helper') != -1) {
        let index = msg.indexOf('helper');
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500); 

        if (this.$route.path !== '/program') {
        this.$router.push({ name: 'Program' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-codexhelper`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Generated Program: ' + message);
        setTimeout(() => {
          this.overlay = false;
        }, 8000);

      } else if (msg.indexOf('assistant') != -1) {
        let index = msg.indexOf('assistant');
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500); 

        if (this.$route.path !== '/intel') {
        this.$router.push({ name: 'Intel' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Commencing enhanced search for' + msg + '.......' + '' + message);
        setTimeout(() => {
        this.overlay = false;
          window.open('https://www.google.com/search?q=' + msg.replace('research', ''), '_blank');
        }, 15000);
        
      } else if (msg.indexOf('ideation') != -1) {
        let index = msg.indexOf('Ideation');
        this.showVoice = true;
        this.overlay = true;

        setTimeout(() => {
        new Audio(startAudioVisual).play();
        }, 500);

        if (this.$route.path !== '/creator') {
        this.$router.push({ name: 'Creator' });
        this.requestType = '';
        msg = msg.slice(index + 9);
        if (msg == '') return;
        }
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence4`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        let message = content.message.replace(/AI/g, '');
        message = message.replace(/:/g, '');
        this.$store.commit('updateMessage', { message });
        this.readOutLoud('Ideation: ' + message);
        setTimeout(() => {
          this.overlay = false;
        }, 8000);
      } else if (msg.indexOf('device detail') != -1 || msg.indexOf('device details') != -1) {
        if (this.$route.path !== '/imei') {
          this.$router.push({ name: 'IMEI' });
          this.readOutLoud('Please tell me the IMEI number');
        } else {
          this.readOutLoud('Please tell me the IMEI number');
        }
      } else if (msg.indexOf('initiate search') != -1) {
        this.requestType = 'search';
        this.readOutLoud('Search initiated, what would you like to search');
        return;
      } else if (msg.indexOf('compose email') !== -1) {
        this.showEmail = true;
      } else if (msg.indexOf('record notes') !== -1) {
        this.showVoiceNotes = true;
      } else if (msg.indexOf('translate conversation') !== -1) {
        this.showVoiceTranslate = true;
      } else if (msg.indexOf('generate invoice') != -1) {
        Event.$emit('generateInvoice', { msg });
        return;
      } else if (msg.indexOf('generate proposal') != -1) {
        Event.$emit('generateProposal', { msg });
        return;
      } else if (msg.indexOf('generate purchase order') != -1) {
        Event.$emit('generatePurchaseOrder', { msg });
        return;
      } else if (msg.indexOf('generate quote') != -1) {
        Event.$emit('generateQuote', { msg });
        return;
      } else if (msg.indexOf('show commands') != -1) {
        Event.$emit('showCommands', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show calendar') != -1) {
        Event.$emit('showCard', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show email') != -1) {
        Event.$emit('showEmail', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show apple') != -1) {
        Event.$emit('showApple', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show samsung') != -1) {
        Event.$emit('showSamsung', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('video chat') != -1) {
        Event.$emit('showVideo', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('screen share') != -1) {
        Event.$emit('showShare', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play mix') != -1) {
        Event.$emit('playMix', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play night') != -1) {
        Event.$emit('playNight', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play tech') != -1) {
        Event.$emit('playTech', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play chill') != -1) {
        Event.$emit('playChill', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play smooth') != -1) {
        Event.$emit('playSmooth', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play cyber') != -1) {
        Event.$emit('playCyber', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play rap') != -1) {
        Event.$emit('playRap', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play hits') != -1) {
        Event.$emit('playHits', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('play urban') != -1) {
        Event.$emit('playUrban', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('close') != -1) {
        Event.$emit('closeCard', { msg }); // This will trigger to open the card
        return;
      } else if (msg.indexOf('show my location') !== -1) {
        //  Using "show" word for google map navigation content
        this.startSpeaking = false;
        this.micOn = false;
        if (this.$route.path !== '/map') {
          this.$router.push({ name: 'Map' });
            this.readOutLoud('Pulling up your location on maps');
            Event.$emit('show my location', { msg });
          setTimeout(() => {
            Event.$emit('show my location', { msg });
            setTimeout(() => {
        const audio = new Audio(startAudio2);
        audio.volume = 0.2; // Set the volume to 50% (value between 0 and 1)
        audio.play();
        }, 100);
          }, 1000);
        } else {
          Event.$emit('show my location', { msg });
        }
      } else if (msg.indexOf('directions to') !== -1) {
        //  Using "show" word for google map navigation content
        this.startSpeaking = false;
        this.micOn = false;
        if (this.$route.path !== '/map') {
          this.$router.push({ name: 'Map' });
            this.readOutLoud('Generating directions to ' + msg.replace('directions to', ''));
            Event.$emit('directions to', { msg });
          setTimeout(() => {
            Event.$emit('directions to', { msg });
            setTimeout(() => {
        const audio = new Audio(startAudio2);
        audio.volume = 0.2; // Set the volume to 50% (value between 0 and 1)
        audio.play();
        }, 100);
          }, 1000);
        } else {
          Event.$emit('directions to', { msg });
        }
      } else if (msg.indexOf('call') !== -1) {
        if (this.$route.path !== '/videocall') {
          this.$router.push({ name: 'VideoCall' });
          setTimeout(() => {
            Event.$emit('new_room', 'Cogneetiv_Group');
          }, 500);
        } else {
          Event.$emit('new_room', 'Cogneetiv_Group');
        }
      } else if (msg.indexOf('briefing') !== -1) {
        if (this.$route.path !== '/dailybriefing') {
          this.$router.push({ name: 'DailyBriefing' });
          this.requestType = '';
          return;
        } else {
          Event.$emit('startbriefing', { msg });
        }
      } else if (msg.indexOf('report') !== -1) {
        if (this.$route.path !== '/analytics') {
          this.$router.push({ name: 'Analytics' });
          setTimeout(() => {
            Event.$emit('graphs', msg);
          }, 500);
        } else {
          Event.$emit('graphs', msg);
        }
      } else {
        if (msg == '') return;

        const rawResponse = await fetch(process.env.VUE_APP_AI_SERVER, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: msg }),
        });
        const content = await rawResponse.json();
        console.log(content[0]);
        if (content[0].custom) {
          switch (content[0].custom.type) {
            case 'text':
              this.readOutLoud(content[0].custom.data);
              break;
            case 'graph':
              if (this.$route.path !== '/analytics') {
                this.$router.push({ name: 'Analytics' });
                setTimeout(() => {
                  Event.$emit('graphs', content[0].custom);
                }, 500);
              } else {
                Event.$emit('graphs', content[0].custom);
              }
              break;
            default:
              this.readOutLoud(content[0].text);
              break;
          }
        } else {
          this.readOutLoud(content[0].text);
        }
      }
    },
  },
  computed: {},
  mounted: function () {
    var childSpanClassAttr = this.$refs.wake.getAttribute ('class');
    
    console.log('<span> was declared with "class" attr -->', childSpanClassAttr);
    
      Event.$on('speakModeOn', () => {
        this.startSpeaking();
      });
  },
  beforeDestroy() {
    Event.$off('speakModeOn');
    Event.$off('openForm');
  },
  beforeMount() {
    this.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    this.recognition = new window.webkitSpeechRecognition();
  },
};
</script>

<style>
.user-speach-2 {
  position: absolute;
  min-width: 0%;
  max-width: 120%;
    bottom: 5px;
    height: 225px;
    float: inherit;
    left: 0px;
    right: 0px;
  border-radius: 20px;
  padding: 10px;
  color: #fff;
  /* transform: translate(-0%, -50%); */
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media (max-width: 600px) {
  .user-speach-2 {
    font-size: 14px;
    min-width: 0%;
    bottom: 50px;
    height: 225px;
    float: inherit;
    left: 0px;
    right: 0px;
    border-radius: 20px;
    padding: 10px;
    color: #fff;
    /* transform: translate(-0%, -50%); */
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
}
.user-speach-3 {
  position: absolute;
  top: 0px;
  font-size: 15px;
  max-width: 25%;
  height: 50px;
  float: inherit;
  right: 45.8%;
  border-radius: 10px;
  color: #fff;
  background-size: 400% 400%;
}
.animation {
  position: absolute;
  bottom: 30px;
  font-size: 15px;
  width: 6%;
  min-height: 0px;
  left: 0px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}
.animation2 {
  position: absolute;
  bottom: 22px;
  min-height: 0px;
  right: 65px;
}
@media only screen and (max-width: 600px) {
.animation2 {
  position: absolute;
  bottom: 22px;
  min-height: 0px;
  right: 40px;
 }
}
.animation3 {
  position: absolute;
  bottom: -18px;
  font-size: 15px;
  min-height: 0px;
  left: 0px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}
@media only screen and (max-width: 600px) {
.animation3 {
  font-size: 15px;
  min-height: 0px;
  left: 0px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
 }
}
.animation4 {
  position: absolute;
  bottom: -50px;
  font-size: 15px;
  min-height: 0px;
  left: 0%;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}
.animation5 {
  position: absolute;
  bottom: -10 0px;
  font-size: 15px; 
  min-height: 0px;
  left: -150px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}
.cardColor {
  background: rgba(19, 26, 64, 0.85) !important;
  border-color: white !important;
  color: #fff;
}
.info-contain {
  text-align: center;
}
.txt-green {
  color: #fff;
  font-size: 35px;
  margin-top: 80px;
  display: inline-block;
}

.footer {
  background: #0c161b;
}
.start-animate {
  animation: shadow-pulse 2s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.3);
  }
  100% {
    box-shadow: 0 0 0 100px rgba(0, 0, 0, 0);
  }
}

@keyframes shadow-pulse-big {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 200px rgba(0, 0, 0, 0);
  }
}
.mic2 {
  width: 30px;
  position: absolute;
  margin-top: 25px;
  left: -0px;
  border-radius: 50%;
  opacity: 1;
}     
.footer {
  width: 100%;
  height: 9.5vh;
  position: fixed;
  bottom: 0px;
  z-index: 10;
	/* background: linear-gradient(-90deg, #0c161b, #0c161b);
  -webkit-animation: gradient 20s ease infinite;
  -animation: gradient 20s ease infinite; */
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.mic {
  width: 80px;
  position: relative;
  top: -15px;
  border-radius: 50%;
  opacity: 0.4;
}
.typing-2 {
  padding: 20px;
  border-radius: 20px;
  min-width: 0%;
  margin-left: 0px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.36em;
  text-align: center;
  background: rgba(37, 50, 68, 0.0);
}


.user-speach {
  position: absolute;
  opacity: 1;
  font-size: 17px;
  max-width: 42%;
  bottom: 225px;
  height: 0px;
  float: inherit;
  left: -20px;
  border-radius: 10px;
  transform: translate(-0%, -50%);
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media (max-width: 600px) {
  .user-speach {
  opacity: 1;
  max-width: 100%;
  bottom: 460px;
  height: 0px;
  float: inherit;
  left: -24px;
  border-radius: 10px;
  /* color: #85c739; */
    /* transform: translate(-0%, -50%); */
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
}

.user-speach3 {
  position: absolute;
  opacity: 1;
  font-size: 17px;
  max-width: 42%;
  bottom: 200px;
  height: 0px;
  float: inherit;
  right: 35px;
  border-radius: 50px;
  transform: translate(-0%, -50%);
  animation-name: slideExpandUp;
  animation-duration: 5s;
  opacity: 0.8 5s;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media (max-width: 600px) {
  .user-speach3 {
  opacity: 1;
  bottom: 80px;
  height: 0px;
  float: inherit;
  left: 250px;
  border-radius: 10px;
  /* color: #85c739; */
    /* transform: translate(-0%, -50%); */
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
}

.typing {
  padding: 15px;
  border-radius: 25px;
  min-width: 0%;
  max-width: 92%;
  margin-left: 50px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.26em;
  text-align: center;
  background: rgba(20, 29, 41, 0.473);
  -webkit-animation: titleAnimation 30s infinite ease;
  -animation: titleAnimation 30s normal forwards ease-in-out;
}
 @keyframes glow4 {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 3px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 1px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 4px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

@keyframes titleAnimation {
  0% {
    transform: translateY(0px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  80% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}

.typing3 {
  padding: 15px;
  border-radius: 25px;
  min-width: 0%;
  max-width: 92%;
  margin-left: 50px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1em;
  text-align: center;
  background: rgba(20, 29, 41, 0.473);
  -webkit-animation: glow4 30s infinite ease;
  -animation: glow4 30s normal forwards ease-in-out;
}
 @keyframes glow4 {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 3px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 1px 0 #000;
    }

    100% {
      border-color: #11ece5;
      box-shadow: 0 0 4px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

@keyframes titleAnimation {
  0% {
    transform: translateY(0px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  80% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}
@media only screen and (max-width: 600px) {
.typing3 {
  padding: 14px;
  border-radius: 25px;
  min-width: 0%;
  max-width: 95%;
  margin-left: 0px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 0.6em;
  text-align: center;
  background: rgba(37, 50, 68, 0.5);
  -webkit-animation: titleAnimation 30s infinite ease;
  -animation: titleAnimation 30s normal forwards ease-in-out;
}

@keyframes titleAnimation {
  0% {
    transform: translateY(0px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  80% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}
}
.card-animate-time {
  animation-name: slideExpandUp;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 3s;
}

.slideExpandUp {
  animation-name: slideExpandUp;
  -webkit-animation-name: slideExpandUp;

  animation-duration: 2.7s;
  -webkit-animation-duration: 2.7s;

  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;

  visibility: visible !important;
}

@keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(10%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-5%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(3%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

@-webkit-keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(10%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-5%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(3%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}
.fade-in-text {
  font-size: 30px;
  vertical-align: middle;
  color: #c1c3d9;
  opacity: 0;
  -webkit-animation: fadeIn linear 3s forwards;
  -moz-animation: fadeIn linear 3s forwards;
  -o-animation: fadeIn linear 3s forwards;
  -ms-animation: fadeIn linear 3s forwards;
  animation: fadeIn linear 3s forwards;
}

.fade-in-text-sub {
  font-size: 20px;
  vertical-align: middle;
  color: #c1c3d9;
  opacity: 0;
  -webkit-animation: fadeIn linear 3s forwards;
  -moz-animation: fadeIn linear 3s forwards;
  -o-animation: fadeIn linear 3s forwards;
  -ms-animation: fadeIn linear 3s forwards;
  animation: fadeIn linear 3s forwards;
  animation-delay: 1s;
}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-o-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-ms-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}



.typing2 {
  padding: 15px;
  /* background: rgba(37, 50, 68, 0.6);
    border-radius: 15px; */
  border-radius: 20px;
  min-width: 0%;
  margin-left: 0px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.26em;

  background: rgba(37, 50, 68, 0.2);
  -webkit-animation: titleAnimation 20s 1 ease;
  -animation: titleAnimation 100s normal forwards ease-in-out;
}

@keyframes titleAnimation {
  0% {
    transform: translateY(-48 px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    -webkit-animation-iteration-count: 1;
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  80% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}

@media only screen and (max-width: 600px) {
.typing2 {
  padding: 15px;
  /* background: rgba(37, 50, 68, 0.6);
    border-radius: 15px; */
  border-radius: 20px;
  min-width: 0%;
  margin-left: 0px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.26em;

  background: rgba(37, 50, 68, 0.2);
  -webkit-animation: titleAnimation 20s 1 ease;
  -animation: titleAnimation 100s normal forwards ease-in-out;
}

@keyframes titleAnimation {
  0% {
    transform: translateY(-48 px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    -webkit-animation-iteration-count: 1;
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  80% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}
}  
.container {
  width: 100%;
  height: 40px;
  position: relative;
}

h1,
h2 {
  font-size: 75px;
  text-transform: uppercase;
}
h1 span {
  animation-delay: 0.6s;
  -webkit-animation-fill-mode: forwards;
}

h2 {
  top: 0;
  position: absolute;
}

.space {
  height: 20px;
}

p.copyright {
    position: absolute;
    width: 100%;
    color: #fff;
    line-height: 10px;
    font-size: 0.7em;
    text-align: right;
    bottom: 15px;
    margin-left: -34px;
  }

.mic-animate {
  margin-top: -30px;
  width: 120px;
  height: 120px;
  /* animation: shadow-pulse 1s infinite; */
  cursor: pointer;
}

.colorful-animation {
  animation: colorful-animation 1s infinite;
  width: 400px;
  height: 100px;
  border-radius: 20px;
  margin-bottom: -50px;
  padding-block: 10px;
  padding-inline: 10px;
  align-items: center;
  justify-content: center;
  color: #000;
}

#start-animate.start-animate {
  animation: mic-animate 1.2s infinite alternate;
  border-radius: 60px;
  width: 60px;
  height: 60px;
}

@keyframes mic-animate {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
    margin-top: -145px;
  }
}
@media only screen and (max-width: 600px) {
  p.copyright {
    position: absolute;
    width: 100%;
    color: #fff;
    line-height: 10px;
    font-size: 0.8em;
    text-align: right;
    bottom: 0px;
    left: 20px;
    opacity: 0.3;
  }
}
</style>
